export default __webpack_public_path__ + "static/media/p1.19c887a3.jpeg";